import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function IllustrationTourCertQualified(props: Props) {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 116.7 38.3"
            xmlSpace="preserve"
            fill="currentColor"
            {...props}
        >
            <g>
                <path
                    d="M71.2,13.4c0.9,0.6,1.8,1.2,2.8,1.8c-0.6,0.9-1.4,1.8-2.3,2.4c-1.9,1.3-4.1,1.8-6.5,1.6c-1.8-0.1-3.5-0.6-5.1-1.6
		c-2.1-1.4-3.5-3.2-4-5.6c-0.6-2.4-0.4-4.7,0.8-6.9c1.3-2.6,3.5-4.2,6.4-4.8c2.3-0.6,4.6-0.4,6.8,0.5C71.8,1.5,73,2.6,74,4.1
		c-0.9,0.6-1.8,1.2-2.7,1.8c-0.4-0.4-0.8-0.8-1.2-1.1c-1.1-0.9-2.4-1.3-3.9-1.3c-1.9,0-3.6,0.6-4.9,2c-0.9,0.9-1.3,2-1.5,3.2
		c-0.2,1.5,0,3,0.8,4.3c1,1.7,2.6,2.6,4.6,2.8c1.4,0.2,2.7,0,3.9-0.6c0.8-0.4,1.4-0.9,1.9-1.6C71.1,13.5,71.1,13.5,71.2,13.4z"
                />
                <path
                    d="M89.3,13.5c-3.6,0-7.2,0-10.8,0c0.1,0.4,0.2,0.7,0.4,1c0.6,1,1.5,1.5,2.7,1.7c1.6,0.3,3.1,0.1,4.5-0.8
		c0.1,0,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.6,0.6,1.1,1.1,1.7,1.7c-0.3,0.3-0.6,0.6-0.9,0.8c-1.2,1-2.6,1.4-4.2,1.6
		c-1.5,0.1-3-0.1-4.4-0.8c-2.1-1-3.4-2.7-3.8-5c-0.3-1.7-0.1-3.4,0.7-5c1.1-2,2.9-3.1,5.2-3.5c1.9-0.3,3.7,0,5.4,1.1
		c1.5,1,2.4,2.4,2.8,4.1C89.4,11.3,89.5,12.5,89.3,13.5z M78.5,10.9c2.5,0,5,0,7.5,0c-0.1-0.7-0.3-1.3-0.9-1.8
		c-1.2-1.1-2.7-1.3-4.2-0.9C79.6,8.6,78.8,9.6,78.5,10.9z"
                />
                <path
                    d="M12,12.1c0-1.9,0.6-3.6,2-5c1.3-1.2,2.8-1.9,4.6-2.1c2.1-0.2,4.1,0.2,5.8,1.5c1.6,1.1,2.5,2.7,2.7,4.5
		c0.2,1.3,0.1,2.6-0.5,3.9c-0.9,2.1-2.5,3.4-4.7,4c-2.9,0.8-5.5,0.3-7.8-1.6c-1.3-1.1-1.9-2.5-2.1-4.1c0-0.1,0-0.3,0-0.4
		C12,12.6,12,12.4,12,12.1z M15.6,12.1c0,0.1,0,0.3,0,0.4c0.2,1.5,0.9,2.6,2.3,3.2c1.8,0.8,3.9,0.1,4.9-1.5c0.5-0.9,0.7-1.8,0.5-2.8
		c-0.4-2.9-3.5-4-5.8-2.8C16.2,9.4,15.6,10.7,15.6,12.1z"
                />
                <path
                    d="M29.3,5.2c1.2,0,2.5,0,3.7,0c0,0.1,0,0.2,0,0.3c0,2.4,0,4.7,0,7.1c0,0.6,0.1,1.2,0.3,1.8c0.5,1.1,1.5,1.7,2.8,1.7
		c1.7,0,2.8-1.1,3-2.7c0-0.3,0-0.6,0-0.9c0-2.3,0-4.7,0-7c0-0.1,0-0.2,0-0.3c1.2,0,2.5,0,3.7,0c0,4.6,0,9.2,0,13.7
		c-1.2,0-2.5,0-3.7,0c0-0.6,0-1.2,0-1.8c-0.3,0.3-0.5,0.6-0.8,0.8c-1,0.9-2.2,1.2-3.5,1.2c-1.4,0-2.7-0.3-3.7-1.2
		c-1-0.8-1.5-1.8-1.7-3c-0.1-0.6-0.2-1.2-0.2-1.8c0-2.6,0-5.2,0-7.8C29.3,5.4,29.3,5.3,29.3,5.2z"
                />
                <path
                    d="M4.7,3.6c-1.6,0-3.2,0-4.7,0c0-1.1,0-2.2,0-3.3c4.4,0,8.8,0,13.3,0c0,1.1,0,2.2,0,3.3c-1.6,0-3.1,0-4.7,0
		c0,5.2,0,10.3,0,15.4c-1.3,0-2.5,0-3.8,0C4.7,13.9,4.7,8.7,4.7,3.6z"
                />
                <path
                    d="M108,1.7c0,1.2,0,2.3,0,3.5c1,0,2,0,3,0c0,1,0,1.9,0,2.8c-1,0-2,0-3,0c0,0.1,0,0.2,0,0.3c0,2.1,0,4.1,0,6.2
		c0,0.2,0,0.5,0.1,0.7c0.2,0.6,0.8,0.8,1.4,0.8c0.4,0,0.8-0.1,1.2-0.1c0.1,0,0.2,0,0.3-0.1c0,0.1,0,0.2,0,0.3c0,0.7,0,1.4,0,2.2
		c0,0.2-0.1,0.4-0.3,0.5c-0.5,0.3-1.1,0.4-1.7,0.4c-0.8,0.1-1.6,0-2.3-0.2c-1.3-0.4-2.1-1.3-2.4-2.6c-0.1-0.4-0.1-0.9-0.1-1.3
		c0-2.2,0-4.5,0-6.7c0-0.1,0-0.2,0-0.3c-0.7,0-1.4,0-2,0c0-0.9,0-1.9,0-2.8c0.7,0,1.3,0,2,0c0-1.2,0-2.3,0-3.5
		C105.5,1.7,106.7,1.7,108,1.7z"
                />
                <path
                    d="M49.5,19c-1.3,0-2.5,0-3.7,0c0-4.6,0-9.2,0-13.8c1.2,0,2.4,0,3.7,0c0,1.1,0,2.2,0,3.4c0.2-0.5,0.4-1,0.7-1.5
		c0.9-1.6,2.6-2.3,4.4-2.1C55,5,55,5.1,55,5.4c0,0.9,0,1.8,0,2.8c0,0.1,0,0.2,0,0.2c-0.6,0-1.3,0-1.9,0.1c-1.8,0.2-3.1,1.5-3.5,3.2
		c-0.1,0.5-0.2,1-0.2,1.6c0,1.8,0,3.7,0,5.5C49.5,18.8,49.5,18.9,49.5,19z"
                />
                <path
                    d="M95.2,8.6c0.3-0.8,0.6-1.5,1.2-2.2c1.1-1.2,2.4-1.6,4-1.4c0.2,0,0.3,0.1,0.3,0.4c0,0.9,0,1.9,0,2.8c0,0.1,0,0.2,0,0.3
		c-0.2,0-0.3,0-0.5,0c-1.4-0.1-2.7,0.2-3.7,1.2c-0.7,0.7-1.1,1.6-1.2,2.5c-0.1,0.4-0.1,0.9-0.1,1.3c0,1.8,0,3.5,0,5.3
		c0,0.1,0,0.2,0,0.3c-1.2,0-2.5,0-3.7,0c0-4.6,0-9.2,0-13.8c1.2,0,2.5,0,3.7,0C95.2,6.4,95.2,7.5,95.2,8.6z"
                />
                <circle cx="115.1" cy="6.4" r="1.6" />
                <g>
                    <path
                        d="M114.3,7.2V5.6h0.7c0.1,0,0.3,0,0.3,0c0.1,0,0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2-0.1,0.3s-0.2,0.1-0.3,0.2
			c0.1,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2l0.3,0.4h-0.3l-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.1-0.1-0.1-0.1-0.1h-0.1h-0.1
			h-0.3v0.7h-0.2V7.2z M114.6,6.3h0.5c0.1,0,0.2,0,0.2,0c0.1,0,0.1-0.1,0.1-0.1V6.1c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.1-0.1-0.3-0.1
			h-0.5v0.5H114.6z"
                    />
                </g>
            </g>
            <g>
                <path
                    d="M63.6,35.9c0.5,0.6,1,1.3,1.5,1.9c-0.3,0.2-0.5,0.4-0.8,0.5c-0.3-0.4-0.7-0.9-1-1.3c-0.2-0.2-0.3-0.4-0.5-0.6
		c-0.1-0.1-0.1-0.1-0.3-0.1c-1.4,0.4-2.7,0.4-4-0.3c-1.7-0.9-2.5-2.3-2.5-4.1s0.8-3.2,2.3-4.2c1.9-1.3,4.8-1.4,6.6,0.3
		c1,1,1.5,2.2,1.4,3.5C66.1,33.4,65.3,34.8,63.6,35.9C63.7,35.8,63.7,35.9,63.6,35.9z M63,35.1c0.5-0.3,0.9-0.6,1.3-1.1
		c0.9-1.3,1.2-2.6,0.6-4.1c-0.6-1.6-2.4-2.4-4.2-2.1c-2.7,0.4-4,2.9-3.6,5c0.4,1.6,1.7,2.7,3.5,2.8c0.5,0,1,0,1.5-0.2
		c-0.4-0.6-0.9-1.1-1.3-1.7c0.3-0.2,0.5-0.4,0.8-0.5C62.1,33.8,62.5,34.5,63,35.1z"
                />
                <path
                    d="M109.8,31.5c0.4-1.7,0.8-3.3,1.1-5c0.3,0,0.6,0,1,0c-0.7,3.3-1.5,6.6-2.2,9.8c-0.3,0-0.6,0-0.9,0c0-0.2,0-0.3,0.1-0.5
		c-0.4,0.3-0.8,0.6-1.3,0.7c-1.9,0.4-3.6-0.7-3.7-2.5c-0.1-1.6,1-3.1,2.7-3.4C107.8,30.3,108.9,30.6,109.8,31.5
		C109.7,31.5,109.7,31.5,109.8,31.5C109.8,31.6,109.8,31.5,109.8,31.5z M104.9,33.7c0,1,0.6,1.8,1.6,2s1.8-0.1,2.5-0.7l0.1-0.1
		c0.2-0.7,0.3-1.4,0.5-2.1c0-0.1,0-0.2-0.1-0.2c-0.4-0.5-0.9-0.8-1.5-0.9C106.4,31.1,104.9,32.1,104.9,33.7z"
                />
                <path
                    d="M79.8,31.6c0.1-0.3,0.2-0.6,0.2-0.9c0.3,0,0.6,0,0.9,0c-0.4,1.9-0.9,3.8-1.3,5.7c-0.3,0-0.6,0-0.9,0c0-0.2,0-0.3,0.1-0.6
		c-0.4,0.4-0.8,0.6-1.3,0.7c-1.8,0.4-3.5-0.8-3.6-2.5c-0.1-1.4,0.7-2.7,2.1-3.3C77.2,30.2,78.8,30.5,79.8,31.6
		C79.8,31.5,79.8,31.5,79.8,31.6z M74.9,33.7c0,1,0.7,1.8,1.8,2c0.9,0.1,1.6-0.2,2.3-0.7c0.1-0.1,0.1-0.2,0.2-0.3
		c0.2-0.7,0.3-1.4,0.4-2c0-0.1,0-0.2-0.1-0.2c-0.4-0.5-0.9-0.8-1.5-0.9C76.4,31.1,74.9,32.1,74.9,33.7z"
                />
                <path
                    d="M97.6,33.6c-0.1,0.8,0.4,1.6,1.2,1.9c0.5,0.2,1,0.2,1.6,0.1c0.5-0.1,0.9-0.5,1.3-0.9c0.3,0.1,0.5,0.2,0.8,0.4
		c-0.5,0.7-1.2,1.2-2,1.4c-1.3,0.3-2.6-0.1-3.3-1.2c-0.6-0.9-0.6-1.8-0.3-2.8c0.5-1.3,1.8-2.1,3.2-2c1.4,0,2.5,1,2.7,2.3
		c0,0.2,0,0.5,0,0.7c0,0.1-0.1,0.1-0.2,0.1c-1.3,0-2.5,0-3.8,0C98.4,33.6,98,33.6,97.6,33.6z M101.9,32.9c-0.1-0.7-0.5-1.2-1.1-1.4
		c-1.1-0.5-2.4,0-2.9,1.1c-0.1,0.1-0.1,0.2-0.1,0.3C99.1,32.9,100.5,32.9,101.9,32.9z"
                />
                <path
                    d="M90.2,31.6c-0.5,0-0.9,0-1.4,0c0.1-0.3,0.1-0.6,0.2-0.9c0.5,0,0.9,0,1.4,0c0.1-0.6,0.2-1.1,0.4-1.7c0.1-0.5,0.2-1,0.4-1.5
		c0.5-1,1.8-1.5,2.9-1.1c0.3,0.1,0.3,0.1,0.2,0.4c0,0.2-0.1,0.4-0.1,0.6c-0.2-0.1-0.4-0.1-0.6-0.2c-0.7-0.1-1.3,0.2-1.5,0.8
		c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.5-0.2,1.1-0.4,1.6v0.1c0.6,0,1.1,0,1.7,0c-0.1,0.3-0.1,0.6-0.2,0.9c-0.6,0-1.1,0-1.7,0
		c-0.1,0.5-0.2,0.9-0.3,1.4c-0.2,1.1-0.5,2.2-0.7,3.3c0,0.1-0.1,0.2-0.2,0.1c-0.3,0-0.5,0-0.8,0C89.5,34.8,89.8,33.2,90.2,31.6z"
                />
                <path
                    d="M68.1,30.7c0.3,0,0.6,0,1,0c-0.1,0.3-0.1,0.7-0.2,1c-0.2,0.9-0.4,1.8-0.6,2.8c0,0.1,0,0.3,0,0.5c0.1,0.5,0.5,0.8,1.1,0.8
		c0.4,0,0.8-0.2,1.1-0.4c0.2-0.2,0.5-0.5,0.7-0.7c0,0,0.1-0.1,0.1-0.2c0.3-1.2,0.5-2.3,0.8-3.5c0-0.2,0.1-0.2,0.3-0.2
		c0.2,0,0.5,0,0.8,0c-0.4,1.9-0.9,3.8-1.3,5.7c-0.3,0-0.6,0-1,0c0.1-0.3,0.1-0.5,0.2-0.8c-0.2,0.1-0.3,0.3-0.4,0.4
		c-0.5,0.4-1,0.6-1.7,0.6c-1,0-1.7-0.8-1.6-1.8c0.1-0.6,0.3-1.3,0.4-1.9c0.1-0.7,0.3-1.4,0.5-2C68.1,30.8,68.1,30.7,68.1,30.7z"
                />
                <path
                    d="M84.1,26.5c0.3,0,0.6,0,1,0c-0.1,0.3-0.1,0.7-0.2,1c-0.6,2.9-1.3,5.7-1.9,8.6c-0.1,0.3-0.1,0.3-0.3,0.3c-0.2,0-0.5,0-0.7,0
		C82.6,33.1,83.4,29.8,84.1,26.5z"
                />
                <path
                    d="M85.2,36.4c0.1-0.4,0.2-0.9,0.3-1.3c0.3-1.4,0.6-2.8,0.9-4.2c0-0.2,0.1-0.2,0.3-0.2c0.2,0,0.5,0,0.8,0
		c-0.1,0.5-0.2,0.9-0.3,1.4c-0.3,1.4-0.6,2.7-0.9,4.1c-0.1,0.3,0,0.2-0.3,0.3C85.6,36.4,85.4,36.4,85.2,36.4z"
                />
                <path
                    d="M93.3,36.4c0.4-1.9,0.9-3.8,1.3-5.7c0.3,0,0.6,0,1,0c-0.1,0.3-0.1,0.7-0.2,1c-0.3,1.5-0.7,3-1,4.5c0,0.1-0.1,0.2-0.2,0.2
		C93.9,36.4,93.6,36.4,93.3,36.4z"
                />
                <path d="M87.5,28.9c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7S87.9,28.9,87.5,28.9z" />
                <path d="M95.6,28.9c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7S96,28.9,95.6,28.9z" />
            </g>
        </svg>
    );
}
